import axios from 'axios';
import { createAsyncAction } from 'redux-promise-middleware-actions';
import settings from '../settings';
import { validateListResponse, validateResponse } from '../utils';

export const GET_WITH_REMOTE = 'GET_WITH_REMOTE';

export const getWithRemote = createAsyncAction(
    GET_WITH_REMOTE,
    async (remote, external) => {
        const headers = { 'Content-Type': 'application/json' };
        const res = await fetch(`${external ? settings.listsUrlApi : (remote.includes('accesor') ? settings.internalListsUrlApi : settings.quotationUrlApi)}${remote}`, { method: 'GET', headers })
            .then((response) => external ? validateListResponse(response) : (remote.includes('accesor') ? validateListResponse(response) : validateResponse(response)));
        
        return res;
    }
);

export const getWithRemoteApi = async (remote, external) => {
    const headers = { 'Content-Type': 'application/json' };
    const res = await fetch(`${external ? settings.listsUrlApi : (remote.includes('accesor') ? settings.internalListsUrlApi : settings.quotationUrlApi)}${remote}`, { method: 'GET', headers })
        .then((response) => external ? validateListResponse(response) : (remote.includes('accesor') ? validateListResponse(response) : validateResponse(response)));
    
    return res;
};
